import { z } from "zod";
import { USER_ROLES } from "../constants.js";

// ログイン入力（Better Auth 経由だが、フォーム検証用に共有）
export const loginInputSchema = z.object({
  email: z.string().email("メールアドレスの形式が正しくありません"),
  password: z.string().min(1, "パスワードを入力してください"),
});
export type LoginInput = z.infer<typeof loginInputSchema>;

// 現在ユーザー（/api/auth/me の出力・allowlist）
export const meResponseSchema = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string(),
  role: z.enum(USER_ROLES),
  schoolId: z.string().nullable(),
  companyId: z.string().nullable(),
  twoFactorEnabled: z.boolean(),
});
export type MeResponse = z.infer<typeof meResponseSchema>;
